// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__35uuA","header":"About_header__1Rwl0","info":"About_info__1zESR","version":"About_version__334hv","allRights":"About_allRights__LWcIQ"};